import { render, staticRenderFns } from "./NonAnswerTopic.vue?vue&type=template&id=9ab44dbc"
import script from "./NonAnswerTopic.vue?vue&type=script&lang=js"
export * from "./NonAnswerTopic.vue?vue&type=script&lang=js"
import style0 from "./NonAnswerTopic.vue?vue&type=style&index=0&id=9ab44dbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports